import { EHR_PILLARS, useStorage } from '@/libs/storage'

export default () => {
  const { getItem } = useStorage(EHR_PILLARS)
  const pillars = getItem()
  return {
    firstPillar: pillars?.firstPillar || {
      id: 'firstPillar',
      queryName: 'primeiraAba',
      isOpen: true,
      activeTab: null,
      tabs: []
    },
    secondPillar: pillars?.secondPillar || {
      id: 'secondPillar',
      queryName: 'segundaAba',
      isOpen: true,
      activeTab: null,
      tabs: []
    },
    thirdPillar: pillars?.thirdPillar || {
      id: 'thirdPillar',
      queryName: 'terceiraAba',
      isOpen: true,
      activeTab: null,
      tabs: []
    },
    personId: undefined,
    draftClinicalRecordId: null
  }
}
